import React from 'react';
import { MainQuantityInput } from 'swag-client-common/components/partials/main-quantity-input';
import { QuantityForColor } from 'swag-client-common/components/partials/quantity-for-color';
import { QuantityPerSize } from 'swag-client-common/components/partials/quantity-per-size';
import classes from './quantity-block.scss';
export const QuantityBlock = ({
  number,
  totalQuantity,
  showPriceBreaks,
  minQuant,
  maxQuant,
  size,
  outOfStockSizes = new Set(),
  variants,
  quantityPerSizeEnabled,
  quantityPerColorEnabled,
  selectedSize,
  onPriceBreakClick,
  onSingleQuantityChange,
  onGeneralQuantityChange,
  onColorQuantityChange,
  className,
  hasMinimum,
  afterMainInputText,
  inStockQuantities,
  indicateMainInputStock,
  totalInStockQuantity = 0,
  titleClassName,
  beforeMainInputText = '',
  subTitleClassName = '',
  sizeContainerClassName = '',
  inputClassName = '',
  quantityPerSizeWrapperClassName = '',
  twoLinesInStockError = false,
  ignoreBigNumber,
  mainQuantityInputContainerClassName = '',
  sizeItemClassName = '',
  sizeItemInputClassName = '',
  sizeItemInputWrapperClassName = '',
  sizeItemLabelClassName = '',
  errorClassName = '',
  disableIfOutOfStock = false,
  quantIncrement,
  validateQuantity,
  stockLevelsByVariantSku = {},
  isRelated,
  productIsAlwaysInStock,
  componentAfterMainQuantityInput,
  sharedItemInfo = {},
  originalSharedItemInfo = {},
  sharedVariants = null
}) => {
  const isDisabledDueToReserve = outOfStockSizes && Object.keys(outOfStockSizes).length === (inStockQuantities === null || inStockQuantities === void 0 ? void 0 : inStockQuantities.length);
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(MainQuantityInput, {
    stockLevelsByVariantSku: stockLevelsByVariantSku,
    isRelated: isRelated,
    productIsAlwaysInStock: productIsAlwaysInStock,
    className: classes.mainInputLine,
    errorClassName: errorClassName,
    onPriceBreakClick: onPriceBreakClick,
    showPriceBreaks: showPriceBreaks,
    onChange: onGeneralQuantityChange,
    minQuant: minQuant,
    maxQuant: maxQuant,
    quantIncrement: quantIncrement,
    quantity: totalQuantity,
    number: number,
    hasMinimum: hasMinimum,
    afterInputText: afterMainInputText,
    beforeInputText: beforeMainInputText,
    containerClassname: mainQuantityInputContainerClassName,
    titleClassName: titleClassName,
    subTitleClassName: subTitleClassName,
    inputClassName: inputClassName,
    validateQuantity: validateQuantity,
    totalInStockQuantity: totalInStockQuantity,
    indicateMainInputStock: indicateMainInputStock,
    twoLinesInStockError: twoLinesInStockError,
    ignoreBigNumber: ignoreBigNumber,
    variants: variants,
    disabled: disableIfOutOfStock && totalInStockQuantity === 0 || isDisabledDueToReserve,
    sharedItemInfo: sharedItemInfo,
    originalSharedItemInfo: originalSharedItemInfo
  }), componentAfterMainQuantityInput, quantityPerSizeEnabled && variants.map((variant, i) => {
    const {
      name,
      color,
      variantIndex,
      quantities,
      colorBehavior = []
    } = variant;
    return /*#__PURE__*/React.createElement(QuantityPerSize, {
      productIsAlwaysInStock: productIsAlwaysInStock,
      key: color,
      sizes: size.options,
      colorValue: color,
      outOfStockSizes: outOfStockSizes,
      inStockQuantities: inStockQuantities,
      stockLevelsByVariantSku: stockLevelsByVariantSku,
      isRelated: isRelated,
      variant: variant,
      showColor: variants.length > 1,
      colorName: name,
      inputClassName: inputClassName,
      quantities: quantities,
      colorBehavior: colorBehavior,
      isShared: sharedItemInfo === null || sharedItemInfo === void 0 ? void 0 : sharedItemInfo.isSharedItem,
      sharedQuantities: sharedVariants === null || sharedVariants === void 0 ? void 0 : sharedVariants[i].quantities,
      sizeContainerClassName: sizeContainerClassName,
      sizeItemClassName: sizeItemClassName,
      sizeItemInputClassName: sizeItemInputClassName,
      sizeItemInputWrapperClassName: sizeItemInputWrapperClassName,
      sizeItemLabelClassName: sizeItemLabelClassName,
      quantityPerSizeWrapperClassName: quantityPerSizeWrapperClassName,
      onChange: ({
        value,
        sizeIndex
      }) => onSingleQuantityChange(value, variantIndex, sizeIndex)
    });
  }), !quantityPerSizeEnabled && quantityPerColorEnabled && variants.map((variant, i) => {
    const {
      name,
      color,
      variantIndex,
      quantities
    } = variant;
    return /*#__PURE__*/React.createElement(QuantityForColor, {
      productIsAlwaysInStock: productIsAlwaysInStock,
      stockLevelsByVariantSku: stockLevelsByVariantSku,
      isRelated: isRelated,
      variant: variant,
      key: color,
      colorValue: color,
      inputClassName: inputClassName,
      showError: true,
      colorName: name,
      quantity: quantities[selectedSize],
      sharedQuantity: sharedVariants === null || sharedVariants === void 0 ? void 0 : sharedVariants[i].quantities[selectedSize],
      quantIncrement: quantIncrement,
      onChange: value => onColorQuantityChange(parseInt((value === null || value === void 0 ? void 0 : value.toString()) || '0', 10), variantIndex)
    });
  }));
};